import { createSelector } from "reselect";
import * as api from "../../../apis/lambdaOperations";

const GET_OVERDUE_OPERATIONS_REQUESTED = "GET_OVERDUE_OPERATIONS_REQUESTED";
const GET_OVERDUE_OPERATIONS_SUCCESS = "GET_OVERDUE_OPERATIONS_SUCCESS";
const GET_OVERDUE_OPERATIONS_FAILED = "GET_OVERDUE_OPERATIONS_FAILED";

export const getOverdueOperations = () => (dispatch) => {
  dispatch({ type: GET_OVERDUE_OPERATIONS_REQUESTED, data: {} });

  api.getOverdueOperations().then((response) => {
    if (response && response.isSuccessful) {
      return dispatch({
        type: GET_OVERDUE_OPERATIONS_SUCCESS,
        data: response.operations,
      });
    } else {
      return dispatch({ type: GET_OVERDUE_OPERATIONS_FAILED, data: {} });
    }
  });
};

const initial = {
  overdueOperations: [],
};

export const reducer = (state = initial, action) => {
  switch (action.type) {
    case GET_OVERDUE_OPERATIONS_SUCCESS:
      return { ...state, overdueOperations: action.data };
    default:
      return { ...state };
  }
};

const mainSelector = (state) => state.lambdaOperations;

export const overdueOperationsSelector = createSelector(
  mainSelector,
  (state) => {
    return state.overdueOperations;
  },
);
